export const SET_TOKEN_ACTION = 'Athena/WritingExamPage/SetTokenAction';
export const SET_TOKEN_ACTION_SUCCESS =
  'Athena/WritingExamPage/SetTokenActionSuccess';
export const SET_TOKEN_ACTION_ERROR =
  'Athena/WritingExamPage/SetTokenActionError';
